import * as actionTypes from '../actions/types';
import { updateObject } from '../../constants/utility';

const initialState = {
    isLoading: false,
    isComplete: null,
    error: null,
    data: null,
};

const paymentsOfferStart = (state) =>
    updateObject(state, { isLoading: true, isComplete: false, error: null });

const paymentsOfferSuccess = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: true,
        error: null,
        data: action.data.offer,
    });

const paymentsOfferFail = (state, action) =>
    updateObject(state, {
        isLoading: false,
        isComplete: null,
        error: action.error,
        data: null,
    });

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.PAYMENTS_OFFER_START:
            return paymentsOfferStart(state);
        case actionTypes.PAYMENTS_OFFER_SUCCESS:
            return paymentsOfferSuccess(state, action);
        case actionTypes.PAYMENTS_OFFER_FAIL:
            return paymentsOfferFail(state, action);
        case actionTypes.PAYMENTS_OFFER_RESET:
            return initialState;
        default:
            return state;
    }
};

export default reducer;
